import { ManageChatConnectors } from "./manage-chat-connectors";

export const ManageChatActions = () => {
  return <ManageChatConnectors type="CONVERSATION_ACTION" />;
};
